<template>
  <div class="h-full py-10 flex justify-center">
    <FortuneWheel
      style="width: 500px"
      :canvas="canvasOptions"
      :prizes="prizes"
      :verify="cavansVerify"
      @rotateStart="onCanvasRotateStart"
      @rotateEnd="onRotateEnd"
    />
  </div>
</template>

<script>
import FortuneWheel from 'vue-fortune-wheel'
import 'vue-fortune-wheel/lib/vue-fortune-wheel.css'

export default {
  name: 'WheelOfFortune',
  components: {
    FortuneWheel
  },
  data () {
    return {
      canvasOptions: {
        fontSize: 20,
        textLength: 15,
        btnText: 'GO'
      },
      prizes: [
        {
          id: 1, //* The unique id of each prize, an integer greater than 0
          name: 'Partner Slot', // Prize name, display value when type is canvas (this parameter is not needed when type is image)
          value: 'Partner Slot', //* Prize value, return value after spinning
          bgColor: '#8c0000', // Background color (no need for this parameter when type is image)
          color: '#ffffff', // Font color (this parameter is not required when type is image)
          probability: 10, //* Probability, up to 4 decimal places (the sum of the probabilities of all prizes
          weight: 1 // Weight, if useWeight is true, the probability is calculated by weight (weight must be an integer), so probability is invalid
        },
        {
          id: 2,
          name: 'Partner Slot',
          value: 'Partner Slot',
          bgColor: '#bd2000',
          color: '#ffffff',
          probability: 10,
          weight: 1
        },
        {
          id: 3,
          name: 'Groceries E-voucher',
          value: 'Groceries E-voucher',
          bgColor: '#fa1e0e',
          color: '#ffffff',
          probability: 10,
          weight: 1
        },
        {
          id: 4,
          name: 'Coffee e-voucher',
          value: 'Coffee e-voucher',
          bgColor: '#ffbe0f',
          color: '#ffffff',
          probability: 10,
          weight: 1
        },
        {
          id: 5,
          name: 'KFC e-voucher',
          value: 'KFC e-voucher',
          bgColor: '#fa1e0e',
          color: '#ffffff',
          probability: 20,
          weight: 1
        },
        {
          id: 6,
          name: '500 Poin Seru',
          value: '500 Poin Seru',
          bgColor: '#bd2000',
          color: '#ffffff',
          probability: 20,
          weight: 1
        },
        {
          id: 7,
          name: 'TAYTB Ultimate Surprise Token',
          value: 'TAYTB Ultimate Surprise Token',
          bgColor: '#8c0000',
          color: '#ffffff',
          probability: 20,
          weight: 1
        }
      ]
    }
  },
  methods: {
    onImageRotateStart () {
      console.log('onRotateStart')
    },
    onCanvasRotateStart (rotate) {
      if (this.canvasVerify) {
        const verified = true // true: the test passed the verification, false: the test failed the verification
        this.DoServiceVerify(verified, 2000).then((verifiedRes) => {
          if (verifiedRes) {
            console.log('Verification passed, start to rotate')
            rotate() // Call the callback, start spinning
            this.canvasVerify = false // Turn off verification mode
          } else {
            alert('Failed verification')
          }
        })
        return
      }
      console.log('onCanvasRotateStart')
    },
    onRotateEnd (prize) {
      alert(prize.value)
    },
    // Simulate the request back-end interface, verified: whether to pass the verification, duration: delay time
    DoServiceVerify (verified, duration) {
      return new Promise((resolve) => {
        setTimeout(() => {
          resolve(verified)
        }, duration)
      })
    }
  }
}
</script>

<style>
</style>
